const processInclude = require('base/util');
document.addEventListener("DOMContentLoaded", function () {
    processInclude(require('./components/pickUpInStore'));
});
